export const subscriptionKeys = {
  all: ['subscription'] as const,
  plans: ['subscription', 'plans'] as const,
  invoices: ['subscription', 'invoices'] as const,
  upcomingInvoice: ['subscription', 'upcoming-invoice'] as const,
};
